import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

const LanguageSwitcher = () => {
  const { lang, setLang, content } = useLanguage();
  const { languageNames } = content.ui;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-1.5 text-gray-300 hover:text-white transition-colors duration-200 text-sm font-medium outline-none">
        <Globe size={18} />
        {languageNames[lang]}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-gray-950 border-gray-800 text-white min-w-[8rem]"
      >
        <DropdownMenuItem
          onClick={() => setLang('en')}
          className="cursor-pointer focus:bg-gray-800 focus:text-white"
        >
          English
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setLang('es')}
          className="cursor-pointer focus:bg-gray-800 focus:text-white"
        >
          Español
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSwitcher;
